var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.56 2.61667L28.51 26.2583C28.1333 27.9233 27.1667 28.2983 25.77 27.5467L18.195 21.96L14.4867 25.505C14.1117 25.8817 13.735 26.2583 12.875 26.2583L13.4667 18.4667L27.5967 5.62667C28.1867 5.035 27.435 4.82 26.6833 5.305L9.115 16.3717L1.53833 14.0617C-0.12667 13.525 -0.12667 12.395 1.915 11.645L31.3567 0.200003C32.8067 -0.229997 34.0433 0.523337 33.56 2.61667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/TG.9435fe835beac2e10abddb8adadc1162.svg";
export { ForwardRef as ReactComponent };